import { render } from "./SignUp.vue?vue&type=template&id=0caba24d&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=0caba24d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caba24d"]])

export default __exports__